
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'primevue/usetoast.js'
import LocationForm from '@/components/LocationForm.vue'
import { getNewKey } from '@/helpers/firebase.ts'
import { db } from '@/services/firebase.ts'
import { getUTC } from '@/helpers/date.ts'
import { Location } from '@/types.ts'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'

export default defineComponent({
  components: { LocationForm, BaseBreadcrumb },
  setup() {
    const toast = useToast()
    const router = useRouter()
    const breadcrumbs = [
      { label: 'Locations', to: '/locations' },
      { label: 'Create' }
    ]

    function create(formData: Location) {
      const utc = getUTC(new Date())
      formData.created = utc
      formData.modified = utc
      formData.active = true

      const newKey = getNewKey('locations')
      db.ref('locations/' + newKey)
        .set(formData)
        .then(() => {
          router.push({ name: 'LocationIndex' })
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Error creating location',
            detail: err.message,
            life: 3000
          })
        })
    }

    return { create, breadcrumbs }
  }
})
